/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthVerifyRegistrationRequest, AuthVerifyRegistrationResponse } from '../types/AuthVerifyRegistration'

/**
 * POST /auth/verify-registration
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::verifyRegistration
 */
export async function authVerifyRegistration(
	data: AuthVerifyRegistrationRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthVerifyRegistrationResponse>> {
	return axiosInstance.post('/auth/verify-registration', data, config)
}
